import { requestAxios } from 'services/api';
import { discountFactory, discountHistoryFactory } from 'factories';
import {
  CommonResponse,
  DiscountInfo,
  DiscountsChangeHistory,
  DiscountsPayload,
} from 'types';
import { getInitialDate } from 'helpers';

interface GetDiscountsParams {
  store: string;
}

async function getDiscount({
  store,
}: GetDiscountsParams): Promise<DiscountInfo> {
  const response = await requestAxios.get(`custom-discount/${store}`);

  const result = response?.data ?? {};

  return discountFactory(result);
}

interface PutDiscountParams {
  store: string;
  newDiscounts: DiscountsPayload;
}

async function putDiscount({
  store,
  newDiscounts,
}: PutDiscountParams): Promise<CommonResponse> {
  const response = await requestAxios.put(
    `custom-discount/${store}`,
    newDiscounts
  );

  return response;
}

interface GetHistoryParams {
  store: string;
  historyFilter: string;
}

async function getHistory({
  store,
  historyFilter,
}: GetHistoryParams): Promise<DiscountsChangeHistory> {
  const historyStartDate = getInitialDate({
    timeDifference: Number(historyFilter),
  });

  const response = await requestAxios.get(
    `custom-discount/${store}/history?historyStartDate=${historyStartDate}`,
    { params: { historyStartDate } }
  );

  const result = response?.data ?? {};

  return discountHistoryFactory(result);
}

export const discountService = {
  getDiscount,
  putDiscount,
  getHistory,
};
